import React, {useContext, useEffect, useState} from "react";
import {  useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "../components/Utils";
import Moment from "react-moment";
import { useMediaQuery } from "react-responsive";
import {clearVideo, getVideo} from "../actions/videos.action";
import PlaylistVideos from "../components/PlaylistVideos";
import VideoJS from "./VideoPlayer";
import { MyContext } from "../contexts/MyContext";
import { Redirect } from "react-router";
import { Helmet } from "react-helmet-async";
import Stripe from "../components/Stripe";
import Video from "../components/Video";
import ShareButton from "../components/player/ShareButton";
import AddFavorite from "../components/player/AddFavorite";
import Rating from "../components/player/Rating";

const Player = ({ match }) => {

	const {
		params: { videoID },
	} = match;

	const dispatch = useDispatch();
	const history = useHistory();
	const videoReducer = useSelector(
		(state) => state.videosReducer.getVideoReducer
	);
	const translations = useSelector(
		(state) => state.langReducer.translationsReducer.translate
	);
	const settings = useSelector((state) => state.settingReducer.getSettingReducer.config);
	const isMobile = useMediaQuery({ query: `(max-width: 1000px)` });
	const [video, setVideo] = useState();
	const [state, setState] = useState(null);
	const [playerClass, setPlayerClass] = useState(null);
	const [ads, setAds] = useState(null);
	const [notHaveAccess, setNotHaveAccess] = useState(false);
	const [needPay, setNeedPay] = useState(false);
	const [needPayMinHierarchy, setNeedPayMinHierarchy] = useState(null);
	const { rootState } = useContext(MyContext);
	const { isAuth } = rootState;
	const [styles, setStyles] = useState({});
	const [playerInitStart, setPlayerInitStart] = useState(false);
	const [options, setOptions] = useState({
		novaskin: "jwlike",
		autoplay: true,
		muted: true,
		controls: true,
		responsive: true,
		playsinline: true,
		fill: true,
		videoId: videoID,
		liveId: null,
		userActions: {
			doubleClick: false
		},
		preload: 'auto',
	});

	useEffect(() => {
		setOptions((prevState) => ({
			...prevState,
			poster: video ? video.poster_desktop : ""
		}))
	}, [video, videoID]);

	useEffect(() => {
		if (settings?.videodescr_bg_color) {
			setStyles((prevState) => ({...prevState, backgroundColor: settings.videodescr_bg_color}));
		}
		if (settings?.videodescr_text_color) {
			setStyles((prevState) => ({...prevState, color: settings.videodescr_text_color}));
		}
	}, [settings]);

	useEffect(() => {
		async function auth() {
			if (isAuth) {
				localStorage.removeItem('loginRedirectUrl');
			} else {
				localStorage.setItem('loginRedirectUrl', window.location);
			}

		}
		if (isAuth !== null) {
			auth();
		}
		// eslint-disable-next-line
	}, [isAuth]);

	useEffect(() => {
		if (videoReducer.result && videoReducer.code === 403) {
			setNotHaveAccess(true);
		} else if (videoReducer.result && videoReducer.code === 401) {
			setState(false)
		} else if (!isEmpty(videoReducer.video)) {
			setNotHaveAccess(false);
			setVideo(videoReducer.video);
			setAds(videoReducer.video?.ads?.data);
		} else {
			setNotHaveAccess(false);
			setVideo(null);
			setAds(null);
		}
	}, [videoReducer, videoID]);

	useEffect(() => {
		setNeedPay(false);
		dispatch(getVideo(videoID));
	}, [videoID]);

	useEffect(() => {
		return () => {
			dispatch(clearVideo());
		};
	}, []);

	//check if player ready and initial datas
	useEffect(() => {
		if (!isEmpty(playerClass) && playerClass.isDisposed_ !== true) {

			if (!isEmpty(ads)) {
				playerClass.fullscreenIphone();
			}

			if (ads?.activated?.AD_PRE_RL) {
				playerClass.preroll()
					.preRollUpdate(
						!isEmpty(ads?.videos) && (!isEmpty(ads?.activated.AD_PRE_RL) && ads?.activated.AD_PRE_RL === true) ?
							ads?.videos :
							{}
					);
			}

			if (ads?.activated?.AD_SP_BNR) {
				playerClass.sponsors()
					.sponsorUpdate(
						!isEmpty(ads?.sp_banner) && (!isEmpty(ads?.activated.AD_SP_BNR) && ads?.activated.AD_SP_BNR === true) ?
							{...ads.sp_banner, displayTime: 5} :
							{
								background: null,
								headings: null,
								logos: null,
								sponsors: null,
								displayTime: 5
							});
			}


			if (ads?.activated?.AD_TBL_LG) {
				playerClass.pills()
					.updateState(
						!isEmpty(ads?.pills) && (!isEmpty(ads?.activated.AD_TBL_LG) && ads?.activated.AD_TBL_LG === true) ? ads?.pills :
							{
								hide_animation: null,
								images: [],
								secondary_display_time: null,
								secondary_times: null,
								show_animation: null

							});
			}


			if (ads?.activated?.AD_UP_TST) {
				playerClass.toasts()
					.toastsUpdate(!isEmpty(ads?.toasts) && (!isEmpty(ads?.activated.AD_UP_TST) && ads?.activated.AD_UP_TST === true) ?
						ads?.toasts :
						{
							primary: null,
							secondary: null,
							secondary_display_time: null,
							secondary_hide_animation: null,
							secondary_show_animation: null,
							secondary_times: null,
						});
			}

			if (ads?.activated?.AD_WTRMRK) {
				playerClass.watermark()
					.updateState(
						!isEmpty(ads?.watermark) && (!isEmpty(ads?.activated.AD_WTRMRK) && ads?.activated.AD_WTRMRK === true) ?
							{
								image: ads?.watermark,
								position: ads?.watermark_position,
								fadeTime: null
							} :
							{
								image: null,
								position: null,
								fadeTime: null
							});
			}


			playerClass.on('needToPay', (event, status) => needToPay(event, status))

			handleInitPlayerReady();

		}
		// eslint-disable-next-line
	}, [ads, playerClass]);

	const needToPay = (event, status) => {
		setNeedPayMinHierarchy(video.subscription.min_hierarchy)
		setNeedPay(status);
	}

	const handlePlayerReady = (player) => {
		setPlayerClass(player);
	};

	//start after init player and implemented ads
	const handleInitPlayerReady =() => {
		if (playerClass && playerClass.isDisposed_ !== true) {
			if (ads?.videos && Object.keys(ads?.videos).length > 0 && playerClass.preroll().ended === false) {

				if (ads?.activated.AD_WTRMRK) {
					playerClass.watermark().hideWaterMark();
				}

				if (ads?.activated.AD_UP_TST) {
					playerClass.toasts().toastsStop();
				}

				if (ads?.activated.AD_TBL_LG) {
					playerClass.pills().pillsStop();
				}

				playerClass.one("endallpreroll",  () => {
					if (!isEmpty(ads?.sp_banner) && ads?.activated.AD_SP_BNR === true) {
						playerClass.sponsors().startSponsors();
						playerClass.one("sponsorstop", () => {
							setPlayerInitStart(true);
						})
					} else {
						setPlayerInitStart(true);
					}
				})
			} else {
				if (!isEmpty(ads?.sp_banner) && ads?.activated.AD_SP_BNR === true) {

					if (ads?.activated.AD_WTRMRK) {
						playerClass.watermark().hideWaterMark();
					}

					if (ads?.activated.AD_UP_TST) {
						playerClass.toasts().toastsStop();
					}


					if (ads?.activated.AD_SP_BNR) {
						playerClass.sponsors().startSponsors();
						playerClass.one("sponsorstop", () => {
							setPlayerInitStart(true);
						})
					}

				} else {
					setPlayerInitStart(true);
				}
			}
		}

	};

	useEffect(() => {
		if (playerInitStart) {

			playerClass.nova({
				automuteButton: false,
				playlistUI: false,
				playlistShow: false,
				playlistAutoHide: true,
				playlistNavigation: false,
				playlistRepeat: false,
				buttonForward: true,
				settingsButton: true,
				theaterButton: false,
				contextMenu: false,
				pipButton: true,
				zoomWheel: true,
				shareMenu: false,
				playsinline: true,
				controls: true,
				preload: true,
				muted: true,
				//ghostThumb: true
			});

			/*playerClass.autoResolution({
			 fetchUrlBandwidth: `${process.env.NEXT_PUBLIC_API_URL}?a=checkBandwidth`
			 });*/


			playerClass.subscription().updateState({
				can_view: video.subscription?.can_view,
				entity: "video"
			});


			playerClass.airplay();

			let playPromise = playerClass.play();
			if (playPromise !== undefined) {
				playPromise.then(function (event) {
					// Automatic playback started!
				}).catch(function (error) {
					//playerClass.pause();
				});
			}

		}
	}, [playerInitStart, video, playerClass]);


	useEffect(() => {
		if (playerInitStart && !isEmpty(video)) {

			let sources = [];
			const currentTime = playerClass?.currentTime();

			if (video?.url?.high) {
				sources.push({
					src: video.url.high,
					type: 'video/mp4',
					label: 'HIGH',
					res: 1080,
				});
			}
			if (video?.url?.med) {
				sources.push({
					src: video.url.med,
					type: 'video/mp4',
					label: 'MED',
					res: 720,
					default: !isMobile
				});
			}

			if (video?.url?.low) {
				sources.push({
					src: video.url.low ,
					type: 'video/mp4',
					label: 'LOW',
					res: 360,
					default: isMobile
				});
			}

			setOptions((prevState) => ({...prevState, sources: sources}))

			playerClass.ready(() => {

				playerClass.watermark().showWaterMark();

				if (currentTime) {
					playerClass.currentTime(currentTime);
				}

				playerClass.play().catch(error => {
					//console.error('Error attempting to play the video:', error);
				});
			});

		}
	}, [playerInitStart, video, isMobile, playerClass]);


	const clickBack = () => {
		if (history.length > 2) {
			history.goBack();
		} else {
			history.push(`/`);
		}
	};

	return (
		<div>

			{!isEmpty(video) && (
				<Helmet>
					<title>{`${process.env.REACT_APP_CLIENT_NAME} - ${video.name}`}</title>
					<meta name="title" content={`${process.env.REACT_APP_CLIENT_NAME} - ${video.name}`} />
					<meta property="og:title" content={`${process.env.REACT_APP_CLIENT_NAME} - ${video.name}`} />
					<meta property="og:description" content={`${video.description}`} />
					<meta property="og:image" content={`${video.poster}`} />
				</Helmet>
			)}

			{state === false && <Redirect to="/account/login" />}
			<div id="video_player_bg"/>
			<div className="player-page container">
				<div className="my-3 d-flex">
					<div className="d-flex cursor-pointer" onClick={() => clickBack()}>
						<span className="back">
							<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 88" fill="none"><circle cx="44" cy="44" r="42" strokeWidth="4" stroke={settings?.general_text_color ? settings.general_text_color : "white"}/><path d="M47.6,60.9L31.5,46.2c-0.7-0.7-1.1-1.4-1.1-2.2c0-0.8,0.4-1.6,1.1-2.2l16.1-14.7c0.5-0.5,1.2-0.8,2-0.8 c1.6,0,2.9,1.2,2.9,2.7c0,0.7-0.3,1.4-0.9,2L37.3,44l14.3,13c0.6,0.5,0.9,1.2,0.9,2c0,1.5-1.3,2.7-2.9,2.7 C48.8,61.7,48.1,61.4,47.6,60.9z" fill={settings?.general_text_color ? settings.general_text_color : "white"}/></svg>
						</span>
						{/*<span className="d-flex my-auto">
							{translations && !isEmpty(translations["back"])
								? translations["back"]
								: "back"}
						</span>*/}
					</div>
				</div>
				<div className="d-flex">
					{!isEmpty(video) && !notHaveAccess && (
						<div className="video-iframe">
							<div className="video position-relative">
								{needPay ? (
									<Stripe
										minHierarchy={needPayMinHierarchy}
										poster={video ? video.poster_desktop : ""}
										entityType={"video"}
										entityId={video?.id}
										priceForView={video?.subscription?.price_per_view}
									/>
								) : (
									<VideoJS
										options={options}
										onReady={handlePlayerReady}
									/>
								)}

							</div>
							<div className="video-data" style={styles}>

								<div className="first-row">

									<h2>{!isEmpty(video) && video.name}</h2>

									<div className="views-block">


										<Rating video={video}/>

										<div className="views">
											{!isEmpty(settings) && settings?.views_counter_visible === "yes" && (
												<span>{video.views} views</span>
											)}

											<Moment format="DD/MM/YYYY">{video.added}</Moment>
										</div>

									</div>
								</div>

								<div className="description">
									<div className="scroll-wrap">
										{video.description}
									</div>
								</div>

								<div className="buttons">

									<AddFavorite video={video}/>

									<ShareButton/>

								</div>

							</div>
						</div>
					)}
					{notHaveAccess && (
						<div className="m-auto d-flex min-height-30">
							<h3 className="m-auto">You don't have permission to view</h3>
						</div>
					)}
				</div>
				{!isMobile ? (
					<div className="similar-video-container">
						{!isEmpty(video) && !isEmpty(video.similar.videos) &&
						<PlaylistVideos
							name={
								translations && !isEmpty(translations["similar_videos"])
									? translations["similar_videos"]
									: "Similar videos"
							}
							videos={video.similar.videos}
						/>
						}
					</div>
				) : (
					<div className="similar-video-container">

						{!isEmpty(video) && !isEmpty(video.similar.videos) && (
							<h3>{translations && !isEmpty(translations["similar_videos"])
								? translations["similar_videos"]
								: "Similar videos"}</h3>
						)}

						<div className="content">
							{!isEmpty(video) && !isEmpty(video.similar.videos) &&
							video.similar.videos.map((video) => {
								return (
									<Video video={video} key={video.id}/>
								)
							})}
						</div>
					</div>

				)}
			</div>
		</div>
	);
};

export default Player;